module.exports = __webpack_public_path__ + "img/14.915adde4.svg";